<template>
  <div class="flex flex-col w-full">
    <Toast position="top-[48px]"></Toast>
    <div class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
      Reset Email
    </div>
    <div class="text-[1rem] leading-[1.5rem] text-[#433D31] font-semibold pt-[8px]">
      Verify your email by entering the 6-digit code sent to
      <span class="font-black text-[#0B0C0F] tracking-[-0.03em]">{{ newEmail }}</span>
    </div>

    <div class="pt-[40px]">
      <div class="w-full flex justify-between mb-[16px]">
        <v-otp-input
          ref="otpInput"
          v-model:value="otpValue"
          input-classes="otp-input"
          input-type="number"
          inputmode="numeric"
          separator=" "
          :num-inputs="6"
          :should-auto-focus="true"
          :is-disabled="loading || maxError"
        />
      </div>

      <p v-if="hasError" class="text-[1rem] text-[#B80A0A] leading-[1.5rem] mt-[4px] block">
        {{ errorMessage }}
      </p>

      <p
        class="text-[1rem] leading-[1.5rem] mt-[32px] mb-[36px] text-[#000000] text-center"
        v-if="!showResendButton && !maxError"
      >
        Resend Code in {{ showResendButtonCount }} sec
      </p>

      <p
        class="text-[1rem] leading-[1.5rem] mt-[32px] mb-[36px] text-[#454BEF] text-center underline cursor-pointer"
        v-if="showResendButton && !maxError"
        @click="resendOtp"
      >
        Resend Code
      </p>

      <p
        class="text-[1rem] leading-[1.5rem] mt-[32px] mb-[36px] text-[#454BEF] text-center underline cursor-pointer"
        v-if="maxError"
        @click="backToPrev"
      >
        Back to previous page
      </p>
    </div>

    <BottomButton
      text="Next"
      :disabled="loading || isSubmitting"
      :loading="isSubmitting"
      @click="handleNext"
      class="my-[32px]"
    />
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import Toast from '@/components/common/Toast.vue';
import VOtpInput from 'vue3-otp-input';
import { mapState } from 'vuex';

export default {
  components: {
    BottomButton,
    Toast,
    VOtpInput,
  },
  props: {
    email: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showResendButton: false,
      showResendButtonCount: 60,
      otpTimer: null,
      otpValue: '',
      hasError: false,
      errorMessage: '',
      maxError: false,
      isSubmitting: false,
    };
  },
  computed: {
    ...mapState('forgotCredentials', {
      countryCode: state => state.mobileData.countryCode,
      mobileNumber: state => state.mobileData.mobileNumber,
      newEmail: 'newEmail',
      loading: 'isLoading',
    }),
  },
  mounted() {
    this.startResendTimer();
  },
  beforeUnmount() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
    }
  },
  methods: {
    startResendTimer() {
      this.showResendButton = false;
      this.showResendButtonCount = 60;

      this.otpTimer = setInterval(() => {
        this.showResendButtonCount--;
        if (this.showResendButtonCount === 0) {
          this.showResendButton = true;
          clearInterval(this.otpTimer);
        }
      }, 1000);
    },

    backToPrev() {
      this.$store.commit('forgotCredentials/setStep', this.step - 1);
    },
    async resendOtp() {
      try {
        this.startResendTimer();
        await this.$store.dispatch('forgotCredentials/sendEmailOtp', this.newEmail);
      } catch (error) {
        console.error(error);
      }
    },

    async handleNext() {
      this.hasError = false;
      if (this.otpValue && this.otpValue.length === 6) {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        try {
          await this.$store.dispatch('forgotCredentials/registerEmail', {
            countryCode: this.countryCode,
            contactNumber: this.mobileNumber,
            email: this.newEmail,
            otp: this.otpValue,
          });
          this.$emit('next');
        } catch (error) {
          this.$refs.otpInput.clearInput();
          //check number of OTP attempts
          const otpAttempts = this.$store.state.forgotCredentials.otpAttempts;
          if (otpAttempts == 3) {
            this.errorMessage = 'Too many wrong attempts, please restart';
            this.maxError = true;
            this.$store.commit('forgotCredentials/setOTPAttempts', 0); // reset attempts after locking out
          } else {
            this.errorMessage = 'Wrong OTP entered, please try again.';
          }
          this.hasError = true;
          console.error(error);
        } finally {
          this.isSubmitting = false;
        }
      }
    },
  },
};
</script>

<style scoped>
:deep(.otp-input) {
  width: 48px;
  height: 69px;
  border-radius: 12px;
  border: 1px solid #d8dadc;
  text-align: center;
  background: #f6f4f0;
  font-size: 18px;
  font-weight: 600;
}

:deep(.otp-input:focus) {
  border: 1.1px solid #454bef;
  outline: none;
}

:deep(input::-webkit-outer-spin-button),
:deep(input::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

:deep(input[type='number']) {
  -moz-appearance: textfield;
}
</style>
